import { createContext, useState, useEffect } from 'react';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [role, setRole] = useState('');
  const [token, setToken] = useState('');

  useEffect(() => {
    const storedData = localStorage.getItem('auth_data');
    if (storedData) {
      const { role, token, expiresAt } = JSON.parse(storedData);
      if (new Date().getTime() < expiresAt) {
        setRole(role);
        setToken(token);
        setIsAuthorized(true);
      } else {
        localStorage.removeItem('auth_data');
      }
    }
  }, []);

  const handleLogin = ({ role, loginToken }) => {
    const expiresAt = new Date().getTime() + 24 * 60 * 60 * 1000;
    const authData = { role: role, token: loginToken, expiresAt };
    setToken(loginToken);
    setRole(role);
    setIsAuthorized(true);
    localStorage.setItem('auth_data', JSON.stringify(authData));
  };

  const handleLogout = () => {
    setRole('');
    setToken('');
    setIsAuthorized(false);
    localStorage.removeItem('auth_data');
  };

  return (
    <UserContext.Provider value={{ role, isAuthorized, token, handleLogin, handleLogout }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
